import { combineReducers } from 'redux'
import smartySharedData from './smartySharedData'
import plans from './plans'
import { groupPlansReducer as groupPlans } from '../groupPlans/reducer'
import { promotionReducer as promotion } from '../promotion/reducer'

export default combineReducers({
  smartySharedData,
  plans,
  promotion,
  groupPlans,
})
